<template>
    <div class="solutionguide">
        <Breadcrumb />
        <StepApplication />
        <StepComponent />
        <StepProperty />
        <StepDecor />
        <StepResult />
        <div v-if="isDebugMode">
    <!--        {{$store.state.segment.name}}-->
    <!--        <ol>-->
    <!--        <li v-for="application in $store.state.segment.applications">-->
    <!--                {{application.name}}-->
    <!--            <ol>-->
    <!--            <li v-for="component in application.components">-->
    <!--                {{component.name}}-->
    <!--                <ol>-->
    <!--                <li v-for="produkt in component.produkte">-->
    <!--                    {{produkt.priority}} - {{produkt.title}}-->
    <!--                </li>-->
    <!--                </ol>-->
    <!--            </li>-->
    <!--            </ol>-->
    <!--        </li>-->
    <!--        </ol>-->
            <hr>
            Anwendung: {{$store.state.application && $store.state.application.name}}<br>
            Komponente: {{$store.state.component && $store.state.component.name}}<br>
            Produkt: {{$store.state.result && $store.state.result.title}}<br>
            selectedDecor: {{$store.getters.selectedDecor}}<br>

            <template v-if="$store.state.component">
                Produkte für Komponente:
                <table>
                    <tr v-for="productId in $store.state.component.productIds">
                        <th>
                            <s v-if="!$store.getters.isProductAvailable($store.getters.getProduct(productId))">{{$store.getters.getProduct(productId).title}}</s>
                            <em v-else>{{$store.getters.getProduct(productId).title}}</em><br>
                            <a :href="$store.getters.getProduct(productId).configApi" target="_blank">Config</a> {{$store.getters.getProduct(productId).decors.length}} Decors
                        </th>
                        <td><ul>
                            <li v-for="id in $store.getters.getProduct(productId).propertyIds">
                                {{$store.getters.getProperty(id).name}}
                            </li>
                        </ul></td>
                        <td>
                            {{ productScore($store.getters.getProduct(productId).propertyIds) }}
                        </td>
                    </tr>
                </table>
                Bestes Produkt: {{bestesProdukt()}}
            </template>
            <hr>
            Alle Produkte
            <table>
                <tr v-for="product in $store.state.segment.productMap">
                    <th><a :href="product.detail_link" target="_blank">{{product.title}}</a></th>
                    <td><a :href="product.configApi" target="_blank">Config</a></td>
                    <td>{{product.decors.length}} Dekore</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script lang="ts">
    import Vue from "vue";
    import StepApplication from "./components/step-application.vue";
    import StepComponent from "./components/step-component.vue";
    import StepProperty from "./components/step-property.vue";
    import StepDecor from "./components/step-decor.vue";
    import StepResult from "./components/step-result.vue";
    import Breadcrumb from "./components/breadcrumb.vue";
    import {SolutionGuide} from "../../../../_types/solutionguide";
    import {mapGetters, mapState} from "vuex";

	export default Vue.extend({
        name: "solutionguide",
        components: {Breadcrumb, StepResult, StepDecor, StepProperty, StepComponent, StepApplication},
        data() {
            return {
                isDebugMode: document.location.hash.indexOf("debug") > -1
            };
        },
        methods: {
            handleResize() {
                this.$store.dispatch('updateViewport')
            },

            productScore(propertyIds: string[]) {
                return this.$store.state.properties.filter((id: string) => propertyIds.includes(id)).length
            },
            bestesProdukt() {
                return this.$store.state.component && this.$store.state.component.productIds.map((productId: string) => this.$store.getters.getProduct(productId)).find((product : SolutionGuide.DekorativePlatte) => this.$store.getters.isProductAvailable(product))
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
        },
        mounted() {
            window.addEventListener('resize', this.handleResize);
            this.$store.subscribeAction((action, state) => {
                if (action.type === 'restart') {
                    this.$el.parentElement?.scrollIntoView({behavior: "smooth"});
                }
            })

            // this.$store.commit('selectApplication', this.$store.state.segment.applications[1]);
            // this.$store.commit('selectComponent', this.$store.state.application.components[1]);
            // this.$store.commit('next')
        }
    })
</script>
